import { render, staticRenderFns } from "./empresa.vue?vue&type=template&id=1a346007&"
import script from "./empresa.vue?vue&type=script&lang=js&"
export * from "./empresa.vue?vue&type=script&lang=js&"
import style0 from "./empresa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports